import { useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { AuthComponent } from '../../components/AuthComponent';
import HomePlaceCard from '../../components/homecards/HomePlaceCard';
import { Container, Row, Col, Card, Image, } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import User2 from '../../../src/assets/images/user2.jpeg'
import User1 from '../../../src/assets/images/user1.jpeg'
import User3 from '../../../src/assets/images/user3.jpg'
import { UsePlaceContext } from '../../hooks/UsePlaceContext';
import { UseAuthContext } from '../../hooks/UseAuthContext';
import {APIProvider, Map, MapCameraChangedEvent, Marker, APILoadingStatus, AdvancedMarker, Pin, InfoWindow} from '@vis.gl/react-google-maps';
import { FaMountainSun } from "react-icons/fa6";
import { GiTreeBranch } from "react-icons/gi";
import { IoIosWater } from "react-icons/io";
import { FaCalendar } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import imageOne from '../../../src/assets/images/imageOne.jpg'
import imageTwo from '../../assets/images/imageTwo.jpg'
import imageThree from '../../assets/images/imageThree.jpg'
import bangladesh from '../../assets/images/bangladesh.jpg'
import turkey from '../../assets/images/turkey.jpg'
import scotland from '../../assets/images/scotland.jpg'
import { FaCity } from "react-icons/fa";
import { FaPeopleGroup } from "react-icons/fa6";
import { IoIosStats } from "react-icons/io";
import { format, set } from 'date-fns';

import './Home.css';



const Home = ()=>{

   
    const [recdata, setRecdata] = useState([]);
    const [freshData, setFreshData] = useState([]);
    const[mapdata, setMapdata] = useState([]);
    const [cardio, setCardio] = useState([]);
    const [cal, setCal] = useState([]);
    const [weight, setWeight] = useState([]);
    const [loader, setLoader] = useState(true);
    const {place, dispatch} = UsePlaceContext();
    const {user, dispatch:authDispatch} = UseAuthContext();

    
    

    const navigate = useNavigate()

    useEffect(()=>{

        
        if (!user) {

            let fetchGoogle = async()=>{

            let data = await fetch("https://mern-exercise-tracker-production.up.railway.app/auth/protected", {
            //let data = await fetch("http://localhost:4000/auth/protected", {

                credentials: "include",
              })
                .then((res) => res.json())
                .then((data) => {
                    
                    const userr = {"name":data.user.username, "email":data.user.email, "token":data.user.token}
                    console.log(userr)
                    authDispatch({type: 'LOGIN', payload:userr})
                  
                    

                }).catch((error)=>{

                    console.log(error)
                })  
           
            }

            fetchGoogle()

         
        }



    }, [])


    /**Fetch all Places */
    useEffect(()=>{


        const fetchApiData = async()=>{

               const data = await fetch('https://mern-exercise-tracker-production.up.railway.app/api/place/home',{
               //const data = await fetch('http://localhost:4000/api/place/home',{

                method: 'GET',

                header: {

                    'Content-Type':'application/json'
                }

            }).then((response)=>{

                return response.json()

            }).then((data)=>{
               
                dispatch({type: 'SET_PLACE', payload: data})
                setLoader(false)
               

            }).catch((error)=>{

                console.log("The error is:", error)
            })
        }

        fetchApiData()





    }, [])

    /**Fetch google map markers */

    useEffect(()=>{

        if(place !== null){

            setRecdata(place.slice(0,12))
            setFreshData(place.slice(0,2))
            setMapdata(place);
          
        } 
      
       },[place])


       const mapStyles = [
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [{ "color": "#000000" }]
        },
        {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [{ "color": "#f2f2f2" }]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [{ "color": "#ffffff" }]
        }
      ]

       
       

    return (
        <AuthComponent>

        <Container>
           

            {/* =====================================================
    HERO
====================================================== */}

<section className="home-hero">

    <Container>

        <div className="hero-top">

            <div className="hero-small-label">
                TRAVEL PALS / 01
            </div>

            <div className="hero-intro">
                <span>DISCOVER</span>
                <span>SHARE</span>
                <span>EXPERIENCE</span>
            </div>

        </div>


        <div className="hero-content">

            <div className="hero-text">

                <h1>
                    Share places.
                    <br />
                    <em>Discover memories.</em>
                </h1>


                <p>
                    Find beautiful places, hidden gems and
                    unforgettable experiences shared by people
                    from around the world.
                </p>


                <div className="hero-buttons">

                    <Button
                        as={NavLink}
                        to="/find"
                        className="hero-button-primary"
                    >
                        Find a place
                        <span>↗</span>
                    </Button>


                    <Button
                        as={NavLink}
                        to="/signup"
                        className="hero-button-secondary"
                    >
                        Share your story
                    </Button>

                </div>

            </div>


            <div className="hero-image-wrapper">

                <div className="hero-image">

                    <Image
                        src={imageThree}
                        fluid
                        alt="Travel destination"
                    />

                    <div className="hero-image-label">

                        <span>FEATURED</span>

                        <strong>
                            Somewhere worth going
                        </strong>

                    </div>

                </div>


                <div className="hero-number">
                    01
                </div>

            </div>

        </div>

    </Container>

</section>


{/* =====================================================
    INTRO
====================================================== */}

<section className="home-discover">

    <Container>

        <div className="discover-heading">

            <div>

                <span className="home-label">
                    EXPLORE
                </span>

                <h2>
                    There's a place
                    <br />
                    <em>for everyone.</em>
                </h2>

            </div>


            <p>
                From quiet forests to mountain trails and
                blue oceans, discover places that inspire
                people to explore something new.
            </p>

        </div>


        {/* =================================================
            EXPERIENCE CARDS
        ================================================== */}

        <div className="experience-cards">


            <div className="experience-card">

                <div className="experience-image">

                    <Image
                        src={imageOne}
                        fluid
                        alt="Mountains"
                    />

                    <span className="experience-number">
                        01
                    </span>

                </div>


                <div className="experience-content">

                    <FaMountainSun />

                    <div>

                        <h3>
                            Mountains
                        </h3>

                        <p>
                            Trails, peaks and places
                            waiting to be explored.
                        </p>

                    </div>

                </div>

            </div>


            <div className="experience-card">

                <div className="experience-image">

                    <Image
                        src={imageTwo}
                        fluid
                        alt="Nature"
                    />

                    <span className="experience-number">
                        02
                    </span>

                </div>


                <div className="experience-content">

                    <GiTreeBranch />

                    <div>

                        <h3>
                            Nature
                        </h3>

                        <p>
                            Escape the ordinary and
                            reconnect with nature.
                        </p>

                    </div>

                </div>

            </div>


            <div className="experience-card">

                <div className="experience-image">

                    <Image
                        src={imageThree}
                        fluid
                        alt="Water"
                    />

                    <span className="experience-number">
                        03
                    </span>

                </div>


                <div className="experience-content">

                    <IoIosWater />

                    <div>

                        <h3>
                            Water
                        </h3>

                        <p>
                            Lakes, oceans and
                            unforgettable horizons.
                        </p>

                    </div>

                </div>

            </div>


        </div>


        {/* =================================================
            FIND CTA
        ================================================== */}

        <div className="find-place-section">

            <div>

                <span className="home-label">
                    READY TO EXPLORE?
                </span>

                <h2>
                    Find somewhere
                    <br />
                    <em>new.</em>
                </h2>

            </div>


            <div className="find-place-right">

                <p>
                    Browse places shared by the Travel Pals
                    community and find your next destination.
                </p>


                <Button
                    as={NavLink}
                    to="/find"
                    className="find-place-button"
                >
                    Find A Place
                    <span>↗</span>
                </Button>

            </div>

        </div>

    </Container>

</section>

            {loader &&  (

                <Button variant="default" disabled>
                <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
                />
                Loading...
                </Button>
                )}

            <Row className='mt-5'>
              

                {
                    
                     recdata.map((singleWorkout)=>{
           
                           return (
                           
                               <HomePlaceCard key={singleWorkout._id} props={singleWorkout} />
                           )
                       })            
                                   
                              
                   }

              
            </Row>



   

            <Row id="map_title_div">

                <Col md={6}>
                    <h2 id="map_title_heading">Explore and Find More Places</h2>
                    <p style={{marginBottom:'0px'}}>All your recently updated Locations</p>
                </Col>

                <Col md={6} style={{height:'100%', marginTop:'auto'}}>

                <Button id="map_title_button" style={{width:'20%', float:'end'}}><NavLink style={{textDecoration:'none', color:'white'}} to="/find">Gallery</NavLink></Button>

                </Col>
                

            </Row> 

           

           

      
   
 
        </Container>

       

       
               

         
        </AuthComponent>
       
       
    )
}

export default Home;